var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.49687 9.33216L6.70904 6.11999C7.85523 4.97376 9.40986 4.3299 11.0308 4.33008V4.33008C13.5297 4.33026 15.7767 5.85161 16.7049 8.17168L16.8358 8.49848",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M6.83159 9.33277H3.49687V5.99805",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M18.5031 12.668L15.2909 15.8801C14.1448 17.0264 12.5901 17.6702 10.9691 17.6701V17.6701C8.47031 17.6699 6.22328 16.1485 5.29512 13.8285L5.16423 13.5016",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M15.1684 12.668H18.5031V16.0027",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecost);
export default __webpack_public_path__ + "static/media/recost.f5f954ad72e3f397bbb64d63f18e5eab.svg";
export { ForwardRef as ReactComponent };